var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.102,
    height: 47.92,
    viewBox: "0 0 59.102 47.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet",
    transform: "translate(-458.298 3000.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M199.64,166.17a4.485,4.485,0,0,0-1.14-1.68V154.8a7.454,7.454,0,0,0-7.22-6.83H150.59a6.833,6.833,0,0,0-6.83,6.83v33.26a6.833,6.833,0,0,0,6.83,6.83h40.69a7.454,7.454,0,0,0,7.22-6.83v-9.69a4.485,4.485,0,0,0,1.14-1.68,13.94,13.94,0,0,0,.54-4.98v-.57A14.112,14.112,0,0,0,199.64,166.17Zm-4.6.5c1.18,0,1.33.38,1.46.72a12.1,12.1,0,0,1,.31,3.75v.57a12.714,12.714,0,0,1-.31,3.75c-.13.34-.28.72-1.46.72H178.79a4.76,4.76,0,0,1,0-9.52h16.25Zm-3.76,24.85H150.59a3.461,3.461,0,0,1-3.46-3.46V154.8a3.461,3.461,0,0,1,3.46-3.46h40.69a3.461,3.461,0,0,1,3.46,3.46v8.5H178.79a8.13,8.13,0,1,0,0,16.26h15.95v8.5A3.468,3.468,0,0,1,191.28,191.52Z",
    transform: "translate(315.038 -3148)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M177.04,171.43a2.18,2.18,0,1,0,2.18-2.18A2.185,2.185,0,0,0,177.04,171.43Z",
    transform: "translate(336 -3148)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9f882cc2dbcd291ed5dc7fd1dcc57919.svg";
export { ForwardRef as ReactComponent };